export const TICKET_DASHBOARD_GET_TABULATED_TICKETS = 'TICKET_DASHBOARD_GET_TABULATED_TICKETS';
export const TICKET_DASHBOARD_GET_PAGES = 'TICKET_DASHBOARD_GET_PAGES';
